const isValidDate = (day: number, month: number, year: number): boolean => {
  if (!Number.isInteger(day) || !Number.isInteger(month) || !Number.isInteger(year)) return false;
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;

  const date = new Date(year, month - 1, day);
  return date.getDate() === day && date.getMonth() === month - 1 && date.getFullYear() === year;
};

export const isFutureDate = (day: number, month: number, year: number): boolean => {
  if (!isValidDate(day, month, year)) return false;

  const date = new Date(year, month - 1, day);
  const now = new Date();

  date.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);

  return date > now;
};
